export default __webpack_public_path__ + "static/media/contact--mobile.b0ddd5dd.webp";